import InspectionBuilder from './InspectionBuilder';

export default InspectionBuilder;
